module.exports = __webpack_public_path__ + "static/media/get-tested.1b01338b.svg";